import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ResponsiveTypography from '../misc/ResponsiveTypography';
import FormHelperText from '@mui/material/FormHelperText';

const ValueCard: React.FC<{
  value: string | number;
  label: string;
  subtitle?: string;
  unit?: string;
  valueTestId?: string;
  maxFontSize?: number;
}> = ({ value, label, subtitle, unit, valueTestId, maxFontSize = 80 }) => {
  return (
    <React.Fragment>
      <Card>
        <CardContent>
          <Typography textAlign="center" variant="h3">
            {label}
          </Typography>

          {subtitle && <FormHelperText sx={{ textAlign: 'center' }}>{subtitle}</FormHelperText>}
          <ResponsiveTypography
            text={typeof value === 'string' ? value : value.toLocaleString()}
            variant="h1"
            maxFontSize={maxFontSize}
            data-testid={valueTestId}
          />
          <Typography textAlign="center">
            {unit ?? '\u00A0' /* non-breaking space to preserve vertical space */}
          </Typography>
        </CardContent>
      </Card>
    </React.Fragment>
  );
};

export default ValueCard;
